// src/Assests/assests.js

// You'll import your images here if they are also in the Assests folder
import vidTubeImage from './vid-tube.jpeg'; // Assuming you have an image for VidTube
import Chatbot from './chatbot.jpeg';
import contactmanager from './contact-manager.jpg';
import hotel from './hotel.jpg';
import snakegame from './snk.jpeg';
import house from './house.jpg';
import weather from './weather.jpeg'

export const featuredProjects = [
    {
    id: 1,
    title: "Stayza",
    description: " A website that helps travelers discover unique stays and accommodations around the globe.",
    image: hotel, // Use the imported image variable
    techStack: [ "Node.js", "MongoDB","javascript", "JWT"],
    liveDemo: "https://stayza-24p3.onrender.com",
     github: "https://github.com/LokendraKumar8/Stayza",
    status: "Live",
    category: "Full Stack"
  },
    
  {
    id: 2,
    title: "Vid-Tube",
    description: " Developed a YouTube-like platform with video search, playback, and navigation features.",
    image: vidTubeImage, // Use the imported image variable
    techStack: ["React Js"],
    liveDemo: "https://you-tube-clone-q95l-d9dshnaxc-lokendrakumar8s-projects.vercel.app/",
    github: "https://github.com/LokendraKumar8/VidTube",
    status: "Live",
    category: "Frontend"
  },
  {
    id: 3,
    title: "Gemi chatbot",
    description: " Created a Gemini-inspired chatbot UI with smooth interactions, API integration, and responsive design.",
    image: Chatbot, // Use the imported image variable
    techStack: ["React"],
    liveDemo: "https://gemini-clone-navy-tau.vercel.app/",
    github: "https://github.com/LokendraKumar8/Gemi-ChatBot",
    status: "Live",
    category: "Frontend"
  },
  {
    id: 4,
    title: "Contact App",
    description: "Developed the backend system for a contact manager application using Node.js, Express, and MongoDB.",
    image: contactmanager, // Use the imported image variable
    techStack: [ "Node.js", "MongoDB", "Express", "JWT"],
    liveDemo: "",
    github: "https://github.com/LokendraKumar8/Contact-app",
    status: "Live",
    category: "Backend"
  },
  {
    id: 5,
    title: "Real-Estate",
    description: " Built a responsive website of Real Estate containing Details about the website,Completed Projects Details,Customer Testimonials,Fully Responsive Contact Form..",
    image: house, // Use the imported image variable
    techStack: ["ReactJs"],
    liveDemo: "https://real-estate-website-seven-sepia.vercel.app/",
    github: "https://github.com/LokendraKumar8/RealEstateWebsite",
    status: "Live",
    category: "FrontEnd"
  },
  
  {
    id: 6,
    title: "Snake Game",
    description: " Built a game with real-time input, collision detection, and scoring system.",
    image: snakegame, // Use the imported image variable
    techStack: ["Javascript"],
    liveDemo: "https://snake-game-project-8ezn.vercel.app/",
    github: "https://github.com/LokendraKumar8/SnakeGame-Project",
    status: "Live",
    category: "FrontEnd"
  }
  
 
];